import {
  FaHashnode,
  FaGithub,
  FaLinkedinIn,
  FaXTwitter,
} from "react-icons/fa6";

const socmedia = [
  {
    id: 1,
    platform: "LinkedIn",
    invitation: "Let's connect on LinkedIn!",
    link: "http://www.linkedin.com/in/amirahnasihah",
    icon: <FaLinkedinIn />,
    brand: "#007AB6",
  },
  {
    id: 2,
    platform: "Twitter",
    invitation: "Stay updated with my tweets!",
    link: "https://twitter.com/amrhnshh",
    icon: <FaXTwitter />,
    brand: "#1da1f2",
  },
  {
    id: 3,
    platform: "GitHub",
    invitation: "Explore my code on GitHub!",
    link: "https://github.com/amirahnasihah",
    icon: <FaGithub />,
    brand: "#24292F",
  },
  {
    id: 4,
    platform: "Hashnode",
    invitation: "Dive into my blog at Hashnode!",
    link: "https://amirahnasihah.hashnode.dev/",
    icon: <FaHashnode />,
    brand: "#2962FF",
  },
];

export default socmedia;
